import { ApiSlugs, ListPagination, TransactionId, TransactionSummaryDto } from '@workspace/data-types';
import { Observable } from 'rxjs';
import { ApiCaller } from '../../../../../api-caller.service';
import { ApiConnector } from '../../../../../api-connector.abstract-service';
import { QueryParamsUtils } from '../../../../../utils/query-params.utils';

export class UserTransactionsAdminConnector extends ApiConnector<
  TransactionSummaryDto,
  TransactionSummaryDto,
  TransactionId
> {
  constructor(apiCaller: ApiCaller, userUrl: string, apiPrefix: string) {
    super(apiCaller, apiPrefix, `${userUrl}/${ApiSlugs.TRANSACTIONS}`);
  }

  summerized = () => ({
    list: (pagination?: ListPagination): Observable<TransactionSummaryDto[]> =>
      this.apiCaller.getRequest<TransactionSummaryDto[]>(
        this.apiPrefix,
        `${this.slug}/all${QueryParamsUtils.buildFilterParams(pagination)}`,
      ),
    count: (pagination?: ListPagination): Observable<number> =>
      this.apiCaller.getRequest<number>(
        this.apiPrefix,
        `${this.slug}/all/count${QueryParamsUtils.buildFilterParams(pagination, true)}`,
      ),
  });
}
